/* tslint:disable */
/* eslint-disable */
/**
 * Tag API
 * API for managing document tags
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { TagFromJSON, TagToJSON, } from './Tag';
/**
 * Check if a given object implements the CreateTagResponse interface.
 */
export function instanceOfCreateTagResponse(value) {
    if (!('tag' in value) || value['tag'] === undefined)
        return false;
    if (!('message' in value) || value['message'] === undefined)
        return false;
    return true;
}
export function CreateTagResponseFromJSON(json) {
    return CreateTagResponseFromJSONTyped(json, false);
}
export function CreateTagResponseFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'tag': TagFromJSON(json['tag']),
        'message': json['message'],
    };
}
export function CreateTagResponseToJSON(json) {
    return CreateTagResponseToJSONTyped(json, false);
}
export function CreateTagResponseToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'tag': TagToJSON(value['tag']),
        'message': value['message'],
    };
}
